import classnames from "classnames";

import { ButtonComponentProps } from "@components/General/Button/button.component";

import { StyleType } from "../types/enums/styleType.enum";
import { Style } from "../types/style.types";

export const createAnchorStyleProperties = (style: Style) => {
    if (style.styleType === StyleType.BUTTON) {
        const { color, outline, fullWidth, size } = style;

        const colorClass = `btn${outline ? "-outline" : ""}-${
            color ?? "primary"
        }`;
        const sizeClass = `btn-${size}`;
        const widthClass = fullWidth ? "btn-block" : undefined;

        return {
            className: classnames("btn", colorClass, sizeClass, widthClass),
        };
    }

    if (style.styleType === StyleType.TITLE) {
        const { color, underline, headingLevel } = style;

        const colorClass = color ? `text-${color}` : undefined;
        const underlineClass =
            underline === "always"
                ? "text-decoration-underline"
                : underline === "never"
                ? "text-decoration-none"
                : undefined;
        const headingClass = headingLevel
            ? `heading-${headingLevel}`
            : undefined;

        return {
            className: classnames(colorClass, underlineClass, headingClass),
        };
    }

    if (style.styleType === StyleType.LINK) {
        return {
            className: "link",
        };
    }
};

export const createButtonStyleProperties = (
    style: Style,
): Partial<ButtonComponentProps> | undefined => {
    if (style.styleType === StyleType.BUTTON) {
        const { color, outline, fullWidth, size } = style;

        return {
            color: color ?? "primary",
            outline: outline,
            fullWidth: fullWidth,
            size: size,
        };
    }

    if (style.styleType === StyleType.TITLE) {
        const { color, underline, headingLevel } = style;

        const colorClass = color ? `text-${color}` : undefined;
        const underlineClass =
            underline === "always"
                ? "text-decoration-underline"
                : underline === "never"
                ? "text-decoration-none"
                : undefined;
        const headingClass = headingLevel
            ? `heading-${headingLevel}`
            : undefined;

        return {
            color: "link",
            className: classnames(colorClass, underlineClass, headingClass),
        };
    }

    if (style.styleType === StyleType.LINK) {
        return {
            color: "link",
            className: "link",
        };
    }
};
